import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  employees: [],
  droppedWorkplace: null,
  droppedStickynote: null,
  isLoading: 'false',
  workplacesFromOtherDepartments: {},
  isCompressed: false,
  date: new Date(),
  isStartOfWeek: true
}


export default (state=initState, action) => {
  switch (action.type) {
    case actionConsts.EDIT_BOOKINGS_REQUEST:
    case actionConsts.EDIT_BOOKINGS_FAILURE:
      return update(state, {
        employees:{
          [action.employeeIndex]: {
            weekdays: {
              [action.weekdayIndex]: {
                bookingItems: {
                  $set: action.bookings
                }
              }
            }
          }
        },
        droppedWorkplace: {
          $set: null
        }
    });
    case actionConsts.CREATE_STICKYNOTE_REQUEST:
        return update(state, {
          employees:{
            [action.employeeIndex]: {
              weekdays: {
                [action.weekdayIndex]: {
                  stickyNotes:{
                    $splice: [[0, 0, action.stickynote]]
                  }
                }
              }
            }
          },
          droppedStickynote: {
            $set: null
          }
        });
    case actionConsts.EDIT_STICKYNOTE_REQUEST:
      return update(state, {
          employees:{
            [action.employeeIndex]: {
              weekdays: {
                [action.weekdayIndex]: {
                  stickyNotes:{
                    [action.stickynoteIndex]:{
                      color: {
                        $set: action.stickynote.color
                      },
                      text: {
                        $set: action.stickynote.text
                      }
                    }
                  }
                }
              }
            }
          },
          droppedStickynote: {
            $set: null
          }
        });
    case actionConsts.CREATE_STICKYNOTE_SUCCESS:
        return update(state, {
          employees:{
            [action.employeeIndex]: {
              weekdays: {
                [action.weekdayIndex]: {
                  stickyNotes:{
                    0: {
                      id: {
                        $set: action.id
                      }
                    }
                  }
                }
              }
            }
          }
        });
    case actionConsts.DELETE_STICKYNOTE_REQUEST:
        return update(state, {
          employees:{
            [action.employeeIndex]: {
              weekdays: {
                [action.weekdayIndex]: {
                  stickyNotes:{
                    $splice: [[action.stickynoteIndex, 1]]
                  }
                }
              }
            }
          },
          droppedStickynote: {
            $set: null
          }
        });
    case actionConsts.ON_WORKPLACE_DROP:
    case actionConsts.OPEN_EDIT_BOOKING_MODAL:
      return update(state, {
        droppedWorkplace: {
          $set: action.droppedWorkplace
        }
    });
    case actionConsts.ON_STICKYNOTE_DROP:
    case actionConsts.OPEN_EDIT_STICKYNOTE_MODAL:
      return update(state, {
        droppedStickynote: {
          $set: action.droppedStickynote
        }
    });
    case actionConsts.CANCEL_WORKPLACE_DROP:
      return update(state, {
        droppedWorkplace: {
          $set: null
        }
    });
    case actionConsts.CANCEL_STICKYNOTE_DROP:
      return update(state, {
        droppedStickynote: {
          $set: null
        }
    });
    case actionConsts.GET_EMPLOYEE_BOOKINGS_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
    });
    case actionConsts.GET_EMPLOYEE_BOOKINGS_SUCCESS:
      return update(state, {
        isLoading: {
          $set: false
        },
        employees: {
          $set: action.employees
        }
    });
    case actionConsts.GET_EMPLOYEE_BOOKINGS_FAILURE:
      return update(state, {
        isLoading: {
          $set: false
        }
    });
    case actionConsts.SET_WORKPLACES_FROM_OTHER_DEPARTMENTS:
      return update(state, {
        workplacesFromOtherDepartments: {
          $set: action.workplaces
        }
    });
    case actionConsts.TOGGLE_IS_COMPRESSED:
      return update(state, {
        isCompressed: {
          $set: action.bool
        }
    });
    case actionConsts.SET_EMPLOYEE_WEEKOVERVIEW_DATE:
      return update(state, {
        date: {
          $set: action.date
        }
    });
    case actionConsts.SET_IS_START_OF_WEEK:
      return update(state, {
        isStartOfWeek: {
          $set: action.bool
        }
    });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/reducer.jsx